<template>
  <div class="contain" v-if="PlayerReady">
      <audio
        ref="audioElement"
        id="audio-source"
        preload="metadata"
        :src="getAudioSrc()"
      ></audio>
          <div class="sm:grid sm:grid-cols-12 holder">

      <div class="sm:col-span-3 poster">
        <img :src="srcPoster" alt="poster_podcast" />
      </div>

      <div class="col-span-12 sm:col-span-9 audio-player">
        <div class="row grid grid-cols-12 infos sm:pt-4 sm:pl-7 pt-1 sm:pl-2 gap-1	sm:gap-0">
          <div class="col-span-3 poster-small">
        <img :src="srcPoster" alt="poster_podcast" />
      </div>
          <Tooltip class="col-span-9 sm:col-span-12 title-tooltip" position="bottom" :tooltipText="audioInfos.audioTitle">
            <h4 class="podcast-title">{{ audioInfos.audioTitle }}</h4>

            </Tooltip>

        </div>

        <div class="audio-container md:m-4 m-0">
          <button
            tabindex="0"
            class="play-btn sm:mx-4 sm:mt-6 mx-1 mt-2"
            v-on:click="playAudio"
            v-if="!playing"
            v-html="SVG.PLAY"
          />
          <button
            tabindex="0"
            class="pause-btn sm:mx-4 sm:mt-6 mx-1 mt-2"
            v-on:click="pauseAudio"
            v-else
            v-html="SVG.PAUSE"
          />

          <div class="w-full p-2">
            <div id="waveform"></div>
            <div class="player flex">
              <div
                class="player-element player-info timestamp w-1/2 pr-4 text-left"
              >
                {{ currentTime }}
              </div>
              <div
                class="player-element player-info duration w-1/2 pl-4 text-right"
              >
                {{ duration }}
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-controls grid grid-cols-2 sm:py-2 sm:px-5 py-1 px-2">
          <div class="flex w-full items-center justify-start">
            <div
              class="volume-control"
              @mouseover="showVolumeRange()"
              @mouseleave="hideVolumeRange()"
            >
              <button
                ref="volumeControl"
                tabindex="0"
                for="volume-range"
                v-html="!volumeValue ? SVG.VOLUME_OFF : SVG.VOLUME_ON"
                @click="handleMuteAudio()"
              />

              <Transition>
                <div class="volume-slider" v-show="volumeSliderShow">
                  <input
                    ref="volumeRange"
                    id="volume-range"
                    type="range"
                    min="0"
                    max="100"
                    v-model="volumeValue"
                    @change="changeAudioVolume()"
                  />
                </div>
              </Transition>
            </div>
            <Tooltip position="top" :tooltipText="$t('buttons.rewindSec')">
              <button
                tabindex="0"
                class="back-btn"
                v-on:click="seekBack"
                v-html="SVG.SEEK_BACK"
              />
            </Tooltip>

            <div
              class="speed-control"
              @mouseover="showSpeedRange()"
              @mouseleave="hideSpeedRange()"
            >
              <button
                ref="speedControl"
                tabindex="0"
                for="speed-range"
                class="speed-text"
              >
                {{ speedValue }}x
              </button>
              <Transition>
                <div class="speed-slider" v-show="speedSliderShow">
                  <input
                    id="speed-range"
                    ref="speedRange"
                    type="range"
                    min="0.25"
                    max="2"
                    step="0.25"
                    v-model="speedValue"
                    @change="changeAudioSpeed()"
                  />
                </div>
              </Transition>
            </div>
            <Tooltip position="top" :tooltipText="$t('buttons.forwardSec')">
              <button
                tabindex="0"
                class="forward-btn"
                v-on:click="seekForward"
                v-html="SVG.SEEK_FORWARD"
              />
            </Tooltip>
          </div>
          <div class="flex w-full items-center justify-end">
            <div
              class="px-1 sm:px-2 flex items-center justify-center"
              @click="showEmbedLinkModal()"
            >
            <Tooltip position="top" :tooltipText="$t('buttons.share')">

              <button
                class="flex items-center justify-center text-xs"
                ref="shareControl"
                tabindex="0"
                v-html="SVG.SHARE"
              >
              </button>
            </Tooltip>

            </div>
            <div class="px-1 sm:px-2">
              <Tooltip position="top" :tooltipText="'RSS'">

              <a
                class="flex items-center justify-center text-xs"
                :href="audioInfos.rssURL"
                target="_blank"
                v-html="SVG.RSS"
              >
             </a
              >
            </Tooltip>

            </div>
            <div v-if="downloadablePodcast" class="px-1 sm:px-2">
              <Tooltip position="top" :tooltipText="$t('buttons.download')">

              <button
                class="flex items-center justify-center text-xs"
                @click="downloadPodcast"
                v-html="SVG.DOWNLOAD"
              >
              </button>
            </Tooltip>

            </div>

            <div class="px-1 sm:px-2">
              <Tooltip position="top" :tooltipText="$t('buttons.descPlayer')">

              <button
                class="flex items-center justify-center text-xs"
                @click="handleShowInfosModal"
                v-html="SVG.INFO_SVG"
              >
              </button>
            </Tooltip>

            </div>

            <InfosModal
              v-if="showInfoModal"
              :information="audioInformations"
              :closeInfosModal="handlCloseInfosModal"
              :duration="duration"
            >
            </InfosModal>
            <EmbedModal
              v-if="embedModalShow"
              :information="embedIframe()"
              :closeEmbedModal="hideEmbedLinkModal"
              :audioInfos="audioInfos"
              :pageURL="audioInfos.embedUrl"
            >
            </EmbedModal>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="loading-container" v-else-if="!PlayerReady && !PlayerError">
    <img class="loading-gif" src="../assets/img/giphy.gif" />
  </div>
  <div class="error-container" v-else>
    <img class="error-img" src="../assets/img/404.png" />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";
import Tooltip from "../components/Tooltip/Tooltip.vue";
import InfosModal from "../components/Modals/InfosModal/InfosModal.vue";
import EmbedModal from "../components/Modals/EmbedModal/EmbedModal.vue";

import { SVG } from "../components/utils/const";
import WaveSurfer from "wavesurfer.js";

import {
  onCreate,
  onPlay,
  onTimeUpdate,
  onSeek,
  onPause,
  onLoad,
  Ended,
  onFirstPlay,
} from "../components/utils/stats";
import { handleUserKeyPress } from "../components/utils/keyboard";
import en from '../../src/i18n/en_US';
import fr from '../../src/i18n/fr_FR';
export default defineComponent({
  name: "PodcastPlayer",
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  components: {
    Tooltip,
    InfosModal,
    EmbedModal,
  },
  data() {
    return {
      SVG,
      showInfoModal: false,
      podcastId:0,
      crypText: "",
      PlayerReady: false,
      PlayerError: false,
      WaveReady: false,
      downloadablePodcast:false,
      audioInformations: {},
      srcAudio: "",
      srcPoster: "",
      currentTime: "00:00",
      duration: "00:00",
      playing: false,
      volumeValue: 0,
      speedValue: 0,
      volumeSliderShow: false,
      speedSliderShow: false,
      embedModalShow: false,

      audioSource: {},
      audioInfos: {} ,

      wavesurfer: {} ,
      queryParams: {},
    };
  },
  computed: {
    pageURL() {
      return window.location.href;
    },

  },
  mounted() {
    const route = useRoute();
    this.crypText = route.params.ct.toString();
    this.queryParams = route.query;
    const searchParams = new URLSearchParams(window.location.search);
    const colorParam = searchParams.get("color");
    const colors = JSON.parse(decodeURIComponent(colorParam));    
    const root = document.documentElement;
    colors?.primary && root.style.setProperty("--primary-color", `rgba(${colors.primary})`);
    colors?.secondary && root.style.setProperty("--secondary-color", `rgba(${colors.secondary})`);
    colors?.tertiary && root.style.setProperty("--tertiary-color", `rgba(${colors.tertiary})`);
    colors?.quaternary && root.style.setProperty("--quaternary-color", `rgba(${colors.quaternary})`);
    this.initData();
  },
  methods: {
    async initData() {
      await axios
        .get(
          `https:${window.process?.env?.API_PLAYER}/api/video/player_param/${this.crypText}/infos`,
          {
            params: this.queryParams,
            headers: {
              authorization: `Bearer ${window.process?.env?.API_TOKEN}`,
            },
          }
        )
        .then((resp) => {
          this.podcastId = resp.data?.data?.playerOptions?.podcastId
          this.srcAudio =
            resp.data?.data?.playerOptions?.sources[0].src;
          this.srcPoster = resp.data?.data?.playerOptions?.poster;
          this.audioInformations = resp.data?.data;
          this.audioInfos.rssURL = resp.data?.data?.infoOptions?.rss_url;
          this.audioInfos.stats_res = resp.data?.data?.statsOptions;
          this.audioInfos.isBo = resp.data?.data?.paramsOptions.isBO;
          this.audioInfos.audioTitle = resp.data?.data?.infoOptions.title;
          this.audioInfos.desc = resp.data?.data?.infoOptions.description;
          this.audioInfos.embedUrl=resp.data?.data?.infoOptions?.url_export_channel;
          this.audioInfos.currentT = 0;
          this.audioInfos.HasSeeked = false;
          this.audioInfos.seekCount = 0;
          this.audioInfos.pauseCount = 0;
          this.audioInfos.autoplay = resp.data?.data?.playerOptions?.autoplay;
          this.downloadablePodcast=resp.data?.data?.downloadOptions?true:false;
          const match = this.srcAudio?.match(/\.([a-z0-9]+)(?:[?#]|$)/i);
          this.PlayerReady = match ? /^(mp3|mp4)$/i.test(match[1]) : false;
          this.PlayerError = match ? !/^(mp3|mp4)$/i.test(match[1]) : true;
        })
        .catch(() => {
          this.PlayerError = true;
          this.PlayerReady = false;
        });

      this.wavesurfer = WaveSurfer.create({
        container: "#waveform",
        progressColor: getComputedStyle(
          document.documentElement
        ).getPropertyValue("--tertiary-color"),
        waveColor: getComputedStyle(document.documentElement).getPropertyValue(
          "--quaternary-color"
        ),
        barHeight: 0.9,
        responsive: true,
        cursorWidth: 0,
        backend: "MediaElement",
      });
      this.wavesurfer.load(this.$refs.audioElement);
      this.wavesurfer.on("seek", () => {
        this.currentTime = this.secondsToTime(
          this.wavesurfer?.getCurrentTime() || 0
        );
      });
      this.wavesurfer.on("ready", () => {
        this.duration = this.secondsToTime(this.wavesurfer?.getDuration());
      });
      this.wavesurfer.on("volume", () => {
        if (parseFloat(this.wavesurfer.getVolume().toFixed(4)) > 0) {
          this.wavesurfer.setMute(false);
        } else {
          this.wavesurfer.setMute(true);
        }
        this.volumeValue =
          parseFloat(this.wavesurfer.getVolume().toFixed(4)) * 100;
      });
      this.wavesurfer.on("waveform-ready", () => {
        const containerAudio = document.querySelector(".contain");
        const waveElement = document.getElementById("waveform");
        waveElement?.classList.add("wave-visible");
        containerAudio?.classList.add("contain-visible");
      });

      if (this.wavesurfer) {
        this.volumeValue =
          parseFloat(this.wavesurfer.getVolume().toFixed(4)) * 100;
        this.speedValue = this.wavesurfer.getPlaybackRate();

        if (!this.audioInfos.isBo) {
          onCreate(this.wavesurfer, this.audioInfos);
          onLoad(this.wavesurfer, this.audioInfos);
          onFirstPlay(this.wavesurfer, this.audioInfos);
          onPlay(this.wavesurfer, this.audioInfos);
          onTimeUpdate(this.wavesurfer, this.audioInfos);
          onSeek(this.wavesurfer, this.audioInfos);
          onPause(this.wavesurfer, this.audioInfos);
          Ended(this.wavesurfer, this.audioInfos);
        }

        window.addEventListener("keydown", (e) => {
          const inputArray = [this.$refs.volumeRange, this.$refs.speedRange];
          if (e.code === "Tab") {
            if (e.target === this.$refs.volumeControl) {
              this.volumeSliderShow = true;
            } else {
              this.volumeSliderShow = false;
            }
            if (e.target === this.$refs.speedControl) {
              this.speedSliderShow = true;
            } else {
              this.speedSliderShow = false;
            }
          } else if (!inputArray.includes(e.target)) {
            handleUserKeyPress(e, this.wavesurfer);
          }
        });

        this.wavesurfer.on("audioprocess", () => {
          this.currentTime = this.secondsToTime(
            this.wavesurfer?.getCurrentTime() || 0
          );
          this.playing = this.wavesurfer.isPlaying();
        });
      }
    },
    embedIframe() {
      return `<iframe src="${this.audioInfos.embedUrl}" style="width: 100%; height: 100%; border: 0 none;" scrolling="no"></iframe>`;
    },
    getAudioSrc() {
      return this.srcAudio;
    },
    changeAudioVolume() {
      this.wavesurfer.setVolume(this.volumeValue / 100);
    },
    changeAudioSpeed() {
      this.wavesurfer.setPlaybackRate(this.speedValue);
    },
    handleMuteAudio() {
      this.wavesurfer.setMute(!this.wavesurfer.getMute());
    },
    showVolumeRange() {
      this.volumeSliderShow = true;
    },
    hideVolumeRange() {
      this.volumeSliderShow = false;
    },
    showSpeedRange() {
      this.speedSliderShow = true;
    },
    hideSpeedRange() {
      this.speedSliderShow = false;
    },
    showEmbedLinkModal() {
      this.embedModalShow = true;
    },
    hideEmbedLinkModal() {
      this.embedModalShow = false;
    },
    secondsToTime(sec) {
      let secNum = parseInt(sec + "", 10);
      let hours = Math.floor(secNum / 3600);
      let minutes = Math.floor((secNum - hours * 3600) / 60);
      let seconds = secNum - hours * 3600 - minutes * 60;
      let stringSec = "" + seconds;
      let stringMin = "" + minutes;

      if (minutes < 10) {
        stringMin = "0" + stringMin;
      }
      if (seconds < 10) {
        stringSec = "0" + stringSec;
      }
      return stringMin + ":" + stringSec;
    },

    playAudio() {
      this.playing = true;
      this.wavesurfer.playPause();
    },
    pauseAudio() {
      this.playing = false;

      this.wavesurfer.playPause();
    },
    seekForward() {
      if (
        this.wavesurfer.getCurrentTime() + 10 <
        this.wavesurfer?.getDuration()
      ) {
        this.wavesurfer.seekTo(
          (this.wavesurfer.getCurrentTime() + 10) /
            this.wavesurfer?.getDuration()
        );
      } else {
        this.wavesurfer.seekTo(1);
      }
    },
    seekBack() {
      if (this.wavesurfer.getCurrentTime() - 10 > 0) {
        this.wavesurfer.seekTo(
          (this.wavesurfer.getCurrentTime() - 10) /
            this.wavesurfer?.getDuration()
        );
      } else {
        this.wavesurfer.seekTo(0);
      }
    },
    handleShowInfosModal() {
      this.showInfoModal = true;
    },
    handlCloseInfosModal() {
      this.showInfoModal = false;
    },
    async downloadPodcast() {
      await axios
        .get(
          `${window.process?.env?.VIDEO_API}/podcast/download/${this.podcastId}`,
          {
            headers: {
              authorization: `Bearer ${window.process?.env?.API_TOKEN}`,
            },
          }
        )
        .then((response) => {
          let fileUrl = response?.data?.data?.file;
          if (fileUrl) {
            window.open(fileUrl, "_blank");
          }
        })
        .catch((e) => {
          console.log("error download", e);
        });
    },
  },
});
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500&display=swap");
@import "./Podcast.css";
</style>
